export default {
	AUTHENTICATION: {
		INVALID_SITUATION: 'La situación del usuario es inválida',
		INVALID_STATUS: 'El estado del usuario es inválido',
		INACTIVE_USER: 'El usuario está inactivo',
		INVALID_USERNAME: 'El usuario es inválido o no existe',
		INVALID_USER: 'El usuario es inválido o no existe',
		INVALID_PASSWORD: 'La contraseña es incorrecta'
	},
	USERS: {
		INVALID_COUNTRY: 'El pais no existe',
		USERNAME_EXISTS: 'El nombre de usuario ya existe',
		EMAIL_EXISTS: 'El correo electrónico ya existe (está en uso por alguien más)',
		INVALID_ROLE: 'Uno o mas roles seleccionados son inválidos',
		INVALID_USER: 'El usuario solicitado no existe',
		NOT_FOUND: 'El usuario solicitado no existe',
		STATUS_NOT_RELATED_TO_USERS: 'La situación a la que se quiere cambiar no pertenece a Usuarios'
  },
  TOKEN: {
		NOT_FOUND: 'El enlace ha expirado, vuelve a solicitar el cambio de tu contraseña'
	}
};



// WEBPACK FOOTER //
// ./src/other/apiErrorMessages.js